<template>
  <div class="main">
    <div class="myTop">
      <div @click="openPop" class="contact">
        <img style="margin-top: 15px;margin-bottom: 4px;" width="19px" height="19px" src="@/assets/img/mobail.png" />
        <span>联系我们</span>
      </div>
      <div v-if="$cookie.get('X-Admin-Token')" @click="$router.push({ name: 'questionInvestigation' })">
        <img width="28px" height="28px" src="@/assets/img/wjdc.png" />
        <span>满意度调查</span>
      </div>
    </div>
    <main-header></main-header>
    <main-content></main-content>
    <main-footer v-if="$route.name != 'cart'"></main-footer>
    <el-dialog title="在线咨询" append-to-body :close-on-click-modal="false" :visible.sync="visible" width="600px">
      <el-form :model="detail" :rules="dataRule" ref="dataForm" label-width="78px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="detail.name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="detail.phone"></el-input>
        </el-form-item>
        <el-form-item label="咨询类型" prop="type">
          <el-select v-model="detail.type" style="width: 100%;">
            <el-option v-for="v in saleUser" :key="v.typeCode" :label="v.typeName" :value="v.typeCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="需求描述" prop="note">
          <el-input type="textarea" :rows="4" v-model="detail.note"></el-input>
        </el-form-item>
        <p style="text-align: center;font-size: 12px;color: #999;">注：业务人员将在24h内反馈，或联系我们：{{ $store.state.pageInfo.contactWay || 'xxx-xxxx xxxx'}}</p>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="formOK">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MainHeader from "./main-header";
import MainContent from "./main-content";
import MainFooter from "./main-footer";
export default {
  components: {
    MainHeader,
    MainContent,
    MainFooter
  },
  data() {
    return {
      visible: false,
      detail: {
        type:'',
        phone:'',
        note:'',
        name:''
      },
      dataRule: {
        type: [
          { required: true, message: "请输入咨询类型", trigger: "change" }
        ],
        phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" }
        ],
        note: [
          { required: true, message: "请输入需求描述", trigger: "blur" }
        ]
      },
      saleUser:[]
    }
  },
  methods: {
    getPerson() {
      this.$http.get(this.$api.shiroApi.getSaleUserList).then(({ data }) => {
        this.saleUser = data.data || [];
      });
    },
    openPop() {
      this.visible = true;
      this.getPerson();
      this.$nextTick(()=>{
        this.$refs["dataForm"].resetFields();
      });
    },
    formOK() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.$http.post(this.$api.shiroApi.sendConsult, this.detail).then(({ data }) => {
            this.$message({
              message: data.msg,
              type: "success"
            });
            this.visible = false;
          });
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  height: 100%;
}

.myTop {
  margin-right: 32px;
  position: fixed;
  right: 0;
  top: 25%;
  z-index: 999;

  &>div,
  .contact {
    cursor: pointer;
    text-align: center;
    width: 68px;
    margin-bottom: 8px;
    height: 68px;
    background: #fff;
    box-shadow: 0px 2px 31px 1px rgba(0, 15, 30, 0.1600);
    border-radius: 8px;
    line-height: 27px;

    img {
      margin: 0 20px;
      margin-top: 10px;
    }

    span {
      font-size: 12px;
      color: #999;
      line-height: 0;
    }
  }
}
</style>
